import { IChatConversation } from 'src/@types/chat';
import { useAuthContext } from 'src/auth/useAuthContext';
import { Roles } from 'src/features/workspace/WorkspaceShareMemberRoleSelectProps';
import { useUserFeatureRole } from 'src/hooks/useUserFeatureRole';

type Props = {
  conversation: IChatConversation;
};

export const useChatAllowedAction = ({ conversation }: Props) => {
  const { user } = useAuthContext();

  const { role } = useUserFeatureRole<Roles, IChatConversation>({
    feature: conversation,
    memberId: user?._id as string,
  });

  if (role === Roles.ADMIN)
    return {
      sendMessage: true,
      manageMembers: true,
      canEditChannel: true,
      canDeleteChannel: true,
      canEditSettings: true,
      isAdmin: true,
      isMember: false,
      isViewer: false,
      role,
    };

  if (role === Roles.VIEWER)
    return {
      sendMessage: false,
      manageMembers: false,
      canEditChannel: false,
      canDeleteChannel: false,
      canEditSettings: false,
      isAdmin: false,
      isMember: false,
      isViewer: true,
      role,
    };

  return {
    sendMessage: true,
    manageMembers: false,
    canEditChannel: false,
    canDeleteChannel: false,
    canEditSettings: false,
    isAdmin: false,
    isMember: true,
    isViewer: false,
    role: role || Roles.MEMBER,
  };
};
